import _ from "lodash";

export type Source =
  | "ichigo_app"
  | "tt_mini_market"
  | "sc_mini_market"
  | "customer_portal"
  | "chargebee_checkout";

export const sources: Source[] = [
  "ichigo_app",
  "tt_mini_market",
  "sc_mini_market",
  "customer_portal",
  "chargebee_checkout",
];

export const selectSources = sources.map((source) => {
  return { value: source, label: source.replaceAll("_", " ").toUpperCase() };
});

export const colorsBySource: Record<Source, string> = {
  ichigo_app: "blue",
  tt_mini_market: "orange",
  sc_mini_market: "violet",
  customer_portal: "cyan",
  chargebee_checkout: "red",
};
